import {
	mapTariffBundlesFormToApi,
	mapTariffHwBundleFormToApi,
	mapHardwareBundleFormToApi,
} from './offerMapper';
import { IOfferConfig } from '../AppTypes';
import { IOfferLimits } from '../../hooks/useOffers';
import {
	AdminApproved,
	CalculationReq,
	Offer,
	ITariffBundle,
	IHardwareBundle,
	ITariffHwBundle,
} from 'api';
import { CalculationResCustomKey } from '../../store/offers/reducer';

export const mapOfferToCalculationReq = (
	offerConfig: IOfferConfig,
	tariffBundles: ITariffBundle[],
	tariffHwBundles: ITariffHwBundle[],
	hardwareBundle: IHardwareBundle,
	wantedPriceTotal: number,
	offerLimits: IOfferLimits,
	definedBudget: number,
	definedBudgetEnteredManually: boolean
): CalculationReq => {
	const res: CalculationReq = {
		offerPurpose: offerConfig.offerPurpose,
		dateCreated: offerConfig.createdDate?.toISOString(),
		calcType: offerConfig.calcType,
		offerDuration: Number(offerConfig.duration),
		portfolioId: Number(offerConfig.portfolioId) || 0,
		preferredDiscount: Number(offerConfig.preferredDiscount) || 0,
		offerVDC: Number(offerConfig.volumeDiscount) || 0,
		tariffBundles: mapTariffBundlesFormToApi(tariffBundles),
		tariffHwBundles: mapTariffHwBundleFormToApi(tariffHwBundles),
		hardwareBundle: mapHardwareBundleFormToApi(hardwareBundle),
		entryTariffDiscount: offerLimits?.entryTariffDiscount,
		limitAmount: offerLimits?.limitAmount,
		noOfSimCardsWithLimit: offerLimits?.noOfSimCardsWithLimit,
		noOfSimTariffOneMinute: offerLimits?.noOfSimTariffOneMinute,
		sumOfWantedHWPrices: wantedPriceTotal,
		definedBudget: definedBudgetEnteredManually ? definedBudget : 0,
		definedBudgetEnteredManually: Number(definedBudgetEnteredManually),
	};
	return res;
};

export const mapOfferToCalculationRes = (
	offer: Offer
): CalculationResCustomKey => {
	const { calculatedValues } = offer;

	let res: CalculationResCustomKey = {
		budgetParams: offer.offerParams?.budgetParams,
		instalmentParams: offer.offerParams?.instalmentParams,
		mustApproveOffer:
			!offer.offerParams?.allowed &&
			offer.offerParams?.adminApproved === AdminApproved.None,
	};

	calculatedValues?.forEach((cv) => {
		if (Object.keys(res).find((k) => k === cv.paramName) !== undefined) {
			if (typeof res[cv.paramName] === 'string') {
				res[cv.paramName] = [res[cv.paramName], cv.paramValue];
			} else {
				res[cv.paramName] = [...res[cv.paramName], cv.paramValue];
			}
		} else {
			res[cv.paramName] = cv.paramValue;
		}
	});

	return res as CalculationResCustomKey;
};
